/**
 * Platform role levels, as the Functions backend judges them.
 *
 * Mirrors CustomerValidation.GetPlatformRoleLevel (SuperAdmin 5, PlatformContributor 4,
 * PlatformReadOnly 3, Unlimited 2). Platform admin endpoints read at 3, write at 4, and keep a
 * few actions (delete a user or tenant, a tenant's plan or lifecycle, Unlimited plan assignment)
 * at 5. The login response also carries IsPlatformAdmin (level >= 4) and IsSuperAdmin (level 5)
 * from the server's own lookup, so either flag raises the level it implies.
 */
const LEVEL_BY_ROLE = {
    SuperAdmin: 5,
    PlatformContributor: 4,
    PlatformReadOnly: 3,
    Unlimited: 2,
};

export const PLATFORM_READ_LEVEL = 3;
export const PLATFORM_WRITE_LEVEL = 4;
export const PLATFORM_SUPERADMIN_LEVEL = 5;

export const getPlatformLevel = (user) => {
    if (!user) return 0;
    if (user.IsSuperAdmin || user.isSuperAdmin) return PLATFORM_SUPERADMIN_LEVEL;
    const byRole = LEVEL_BY_ROLE[user.Role || user.role] || 0;
    return Math.max(byRole, (user.IsPlatformAdmin || user.isPlatformAdmin) ? PLATFORM_WRITE_LEVEL : 0);
};

/** May open Admin Settings and read every platform surface on it. */
export const canReadPlatformAdmin = (user) => getPlatformLevel(user) >= PLATFORM_READ_LEVEL;

/** May change platform settings, users, tenants, plans and templates. */
export const canWritePlatformAdmin = (user) => getPlatformLevel(user) >= PLATFORM_WRITE_LEVEL;

/** May take the SuperAdmin-only actions. */
export const isPlatformSuperAdmin = (user) => getPlatformLevel(user) >= PLATFORM_SUPERADMIN_LEVEL;
